var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "info-banner" },
          [
            _c("a-alert", {
              attrs: {
                message: _vm.$t(
                  "whatsapp_business_api.metaInsightsTemplateAboutTitle"
                ),
                description: _vm.$t(
                  "whatsapp_business_api.metaInsightsTemplateAboutDesc"
                ),
                type: "info",
                "show-icon": "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "template-selector" },
          [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "whatsapp_business_api.metaInsightsTemplateSelectLabel"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  mode: "multiple",
                  value: _vm.selectedTemplateIds,
                  placeholder: _vm.$t(
                    "whatsapp_business_api.metaInsightsTemplateSelectPlaceholder"
                  ),
                  "max-tag-count": 5,
                },
                on: { change: _vm.onTemplateSelect },
              },
              _vm._l(_vm.templates, function (template) {
                return _c(
                  "a-select-option",
                  { key: template.id, attrs: { value: template.id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(template.name) +
                        " (" +
                        _vm._s(template.language) +
                        ")\n                "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "fetch-btn",
                attrs: {
                  type: "primary",
                  disabled: _vm.selectedTemplateIds.length === 0,
                },
                on: { click: _vm.fetchData },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("whatsapp_business_api.metaInsightsFetchData")
                    ) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading && _vm.data && _vm.data.data && _vm.data.data.length > 0
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewChart"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewChart') }",
                          },
                        ],
                        attrs: {
                          classNames: !_vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = false)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewTable"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewTable') }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = true)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsDownloadExcel"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsDownloadExcel') }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalSent"
                      ),
                      value: _vm.totalSent,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalDelivered"
                      ),
                      value: _vm.totalDelivered,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalRead"
                      ),
                      value: _vm.totalRead,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsReadRate"
                      ),
                      value: _vm.readRate,
                      unit: "%",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.tableMode
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: _vm.$t(
                            "whatsapp_business_api.metaInsightsTemplatePerformance"
                          ),
                          "x-axis-data": _vm.getXAxisData(),
                          legends: [
                            _vm.$t("whatsapp_business_api.metaInsightsSent"),
                            _vm.$t(
                              "whatsapp_business_api.metaInsightsDelivered"
                            ),
                            _vm.$t("whatsapp_business_api.metaInsightsRead"),
                          ],
                          colors: ["#37A2FF", "#80FFA5", "#FFBF00"],
                          series: _vm.getSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.hasCostData
                ? _c("div", { staticClass: "cost-section" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.metaInsightsCostInfo")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cost-cards" }, [
                      _c("div", { staticClass: "cost-card" }, [
                        _c("div", { staticClass: "cost-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.metaInsightsTotalSpent"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cost-value" }, [
                          _vm._v("$" + _vm._s(_vm.totalAmountSpent.toFixed(2))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cost-card" }, [
                        _c("div", { staticClass: "cost-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.metaInsightsCostPerDelivered"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cost-value" }, [
                          _vm._v(
                            "$" + _vm._s(_vm.avgCostPerDelivered.toFixed(4))
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasClickData
                ? _c("div", { staticClass: "click-section" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.metaInsightsClickInfo")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "click-info" }, [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.metaInsightsClickInfoDesc"
                              )
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description: _vm.$t(
                      "whatsapp_business_api.metaInsightsTemplateNoData"
                    ),
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }